import { render, staticRenderFns } from "./EditMarket.vue?vue&type=template&id=05c8a280&scoped=true&"
import script from "./EditMarket.js?vue&type=script&lang=js&"
export * from "./EditMarket.js?vue&type=script&lang=js&"
import style0 from "./EditMarket.vue?vue&type=style&index=0&id=05c8a280&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c8a280",
  null
  
)

export default component.exports